import * as headerStyles from "./header.module.scss";

import { StaticImage } from "gatsby-plugin-image";
import { Link, graphql, useStaticQuery } from "gatsby";
import React, { useEffect, useState } from "react";
import icon1 from "../../images/home/icon_1.svg";
import icon2 from "../../images/home/icon_2.svg";
import icon3 from "../../images/home/icon_3.svg";
import icon4 from "../../images/home/icon_4.svg";
import crossButton from "../../images/home/crossButton.svg";
import ButtonComponent from "../../components/Home/ButtonComponent/ButtonComponent";
import { useDisclosure } from "@mantine/hooks";
import { Modal } from "@mantine/core";
import SlideUpForm from "../../components/SlideUpForm/SlideUpForm";
import logoLight from '../../images/home/logo.png';
import logoDark from '../../images/home/logo-dark-v2.png';
import { useViewportSize } from '@mantine/hooks';
import { config } from "../../config";
import { usePageWrapperContext } from '../PageWrapper/PageWrapper'

function transformJson(json) {
  const baseUrl = config.wp_url;

  function removeBaseUrl(obj) {
      if (Array.isArray(obj)) {
          return obj.map(removeBaseUrl);
      } else if (typeof obj === "object" && obj !== null) {
          const newObj = {};
          for (const key in obj) {
              if (key === "url" && typeof obj[key] === "string" && obj[key].startsWith(baseUrl)) {
                  newObj[key] = obj[key].replace(baseUrl, "");
              } else {
                  newObj[key] = removeBaseUrl(obj[key]);
              }
          }
          return newObj;
      }
      return obj;
  }

  return removeBaseUrl(json);
}

export default function Header({ blogHeader }) {
  const { isFormModalOpen, changeModalState  } = usePageWrapperContext();
  const [opened, { open, close }] = useDisclosure(false);
  const [scroll, setScroll] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [currentUrl, setCurrentUrl] = useState([]);
  const [showSubMenu, setShowSubMenu] = useState(false);
  const [mobileSubMenuBoxHeight,setMobileSubMenuBoxHeight] = useState(0);
  const [innerWidth, setInnerWidth] = useState(0);
  const [pathName, setPathName] = useState(null);
  const [submenuActive, setSubmenuActive] = useState(false);

  const { width } = useViewportSize();

  const handleShowSubMenu = () => {
    setShowSubMenu(!showSubMenu);
    const subMenuMobileHeight = document.getElementById("mobileSubMenuBox");
    setMobileSubMenuBoxHeight(subMenuMobileHeight.scrollHeight);
  };

  useEffect(() => {
    const isBrowserC = typeof window !== "undefined";
    if (isBrowserC) {
      setCurrentUrl(window.location.href.split('/'));
      window.addEventListener("scroll", () => {
        setScroll(window.scrollY > 250);
      });
      document.body.classList.toggle("navOpen", menuOpen);
      setInnerWidth(window.innerWidth);
    }
  }, [menuOpen]);

  let data = useStaticQuery(graphql`
    query {
      allWpMenu(filter: { id: { eq: "dGVybTo1MTY4" } }) {
        edges {
          node {
            menuItems {
              nodes {
                label
                url
              }
            }
          }
        }
      }

      wp {
        themeGeneralSettings {
          themeOptionsAcf2 {
            megaMenu {
              megaMenuOne {
                title
                description
                link
                image {
                  altText
                  gatsbyImage(
                    quality: 90
                    width: 1000
                    layout: CONSTRAINED
                    placeholder: BLURRED
                  )
                  localFile {
                    childImageSharp {
                      gatsbyImageData(
                        quality: 90
                        formats: [AUTO, WEBP]
                        layout: CONSTRAINED
                        placeholder: BLURRED
                      )
                    }
                  }
                }
              }
              megaMenuTwo {
                title
                link
              }
            }
          }
        }
      }
    }
  `);

  data = transformJson(data);

  function updatedMegaMenuData(data) {
    const updatedMegaMenuUrl = (array) => {
      return array?.map( key => {
        return {
          ...key,
          link: `/${key.link.split('/').filter(Boolean).pop()}`
        }
      })
    };
    return {
      megaMenuOne: updatedMegaMenuUrl(data.megaMenuOne),
      megaMenuTwo: updatedMegaMenuUrl(data.megaMenuTwo),
    }
  }

  const headerMenu = data?.allWpMenu?.edges[0]?.node.menuItems.nodes || [];
  const megaMenu = updatedMegaMenuData(data?.wp?.themeGeneralSettings?.themeOptionsAcf2?.megaMenu);

  function handleMenuClose() {
    setMenuOpen(!menuOpen);
    setShowSubMenu(false);
  }

  const getHighlightColor = (label, url) => {
    if (label === "Our Works" && url.includes('case-study')) {
      return '#e40a65';
    } else if (label === "Blog" && url.includes('blog')) {
      return '#e40a65';
    }
    return '';
  };

  const MenuItem = ({ item, showSubMenu, handleShowSubMenu }) => {
    if (item.label === "Services") {
      return (
        <div 
          className={`${headerStyles.servicesInMobile} ${submenuActive ? 'active' : ''}`}
          style={{color: `${submenuActive ? '#e40a65' : ''}`}}
          onClick={handleShowSubMenu}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              handleShowSubMenu();
            }
          }}
          role="button"
          tabIndex="0"
          aria-label="Show Submenu"
        >
          {item.label} 
          <span className={`${headerStyles.caretDropdown} ${showSubMenu ? headerStyles.caretDropdownClose : ""}`}></span>
        </div>
      );
    }
    
    return <Link to={item.url} style={{ color: `${getHighlightColor(item.label, currentUrl)}`}}>{item.label}</Link>;
  };

  useEffect(() => {
    if (typeof window !== "undefined") {
      setPathName(window.location.pathname);
      setSubmenuActive(document.querySelector("#mobileSubMenuBox a[aria-current='page'], .megaMenuWrapper a[aria-current='page']"))
    }
  }, []);

  // ----==== For dark or light header ====----
  function GetLightOrDarkHeader() {
    const isBlog = currentUrl.includes('blog');
    const isCaseStudy = currentUrl.includes('case-study');
    const excludedPaths = ['ar-vr-website-design', 'seo-ux-design', 'dashboard-ui-ux-design', 'nft-marketplace-ui-design', 'saas-app-design', 'library-mobile-app-design', 'ecommerce-fashion-website-design', 'b2b-saas-product-design', 'healthcare-analytics-ux', 'job-portal-ui-ux-design'];
    const isExcluded = excludedPaths.some(path => currentUrl.includes(path));
  
    return isBlog || (isCaseStudy && !isExcluded);
  }

  useEffect(() => {
    if (isFormModalOpen) {
      open()
    } else {
      close();
    }
  }, [isFormModalOpen, open])

  function closeModal() {
    close();
    changeModalState(false);
  }

  return (
    <>
      <header
        id="head"
        className={
          scroll
            ? `${headerStyles.header} ${headerStyles.fixed} hFixed`
            : `${headerStyles.header}`
        }
      >
        <span></span>
        <div
          className={
            blogHeader === true
              ? `${headerStyles.headerInner} ${headerStyles.blog_header} headerStyles_headerInner`
              : `${headerStyles.headerInner} headerStyles_headerInner`
          }
        >
          <div className={`${headerStyles.logoContainer} headerStyles_logoContainer`}>
            <Link to="/">
              <div className={headerStyles.largeImg}>
                <img src={GetLightOrDarkHeader() ? logoDark : logoLight} alt="logo" />
              </div>

              <div className={`${headerStyles.smallImg} headerStyles_smallImg`}>
                <StaticImage
                  src="../../images/home/logo-small.png"
                  alt="logo"
                  width={86}
                />
              </div>
            </Link>
          </div>
          <button
            className={`
              ${headerStyles.menu} 
              ${GetLightOrDarkHeader() ? headerStyles.blogAndCaseStudy : ""}
              ${menuOpen ? headerStyles.menuOpen : ""}
            `}
            onClick={handleMenuClose}
          >
            <div>MENU</div>
            <div
              className={`${headerStyles.menuIcon} ${
                menuOpen ? headerStyles.menuOpenIcon : ""
              }`}
            >
              <span></span>
              <span></span>
            </div>
          </button>
          <div className={`${headerStyles.navigation} navigationWrapper`}>
            <nav>
              <ul>
                {headerMenu.map((item, index) => (
                  <li key={`arrayElement${index}`}>
                    <Link 
                      to={item?.url} 
                      style={{color: `${(item.label === "Services" && submenuActive) || (item.label === "Our Works" && currentUrl.includes('case-study')) ? '#e40a65' : ''}`}} 
                    >
                      {item.label}
                    </Link>
                    {item.label === "Services" && (
                      <div className={`${headerStyles.mega_menu_wrap} megaMenuWrapper`}>
                        <div className={headerStyles.container}>
                          <div className={headerStyles.col_9}>
                            <ul>
                              <li>
                                <img
                                  src={icon1}
                                  alt="icon1"
                                />
                                <div className={headerStyles.menu_h_text}>
                                  <Link to="/ux-research-services">
                                    UI/UX Research
                                  </Link>
                                </div>
                                <Link
                                  to="/ux-research-services"
                                  className={headerStyles.readMore}
                                >
                                  Read More
                                </Link>
                              </li>
                              <li>
                                <img
                                  src={icon2}
                                  alt="icon2"
                                />
                                <div className={headerStyles.menu_h_text}>
                                  <Link to="/mobile-app-ui-design-services/">
                                    App Design
                                  </Link>
                                </div>
                                <Link
                                  to="/mobile-app-ui-design-services/"
                                  className={headerStyles.readMore}
                                >
                                  Read More
                                </Link>
                              </li>
                              <li>
                                <img
                                  src={icon3}
                                  alt="icon3"
                                />
                                <div className={headerStyles.menu_h_text}>
                                  <Link to="/custom-website-design-development/">
                                    Website Design
                                  </Link>
                                </div>
                                <Link
                                  to="/custom-website-design-development/"
                                  className={headerStyles.readMore}
                                >
                                  Read More
                                </Link>
                              </li>
                              <li>
                                <img
                                  src={icon4}
                                  alt="icon4"
                                />
                                <div className={headerStyles.menu_h_text}>
                                  <Link to="/brand-identity-design-services/">
                                    Brand Design
                                  </Link>
                                </div>
                                <Link
                                  to="/brand-identity-design-services/"
                                  className={headerStyles.readMore}
                                >
                                  Read More
                                </Link>
                              </li>
                            </ul>
                          </div>
                          <div className={headerStyles.col_3}>
                            <ul>
                              {megaMenu?.megaMenuTwo.map((item, index) => (
                                <li key={`arrayElement${index}`}>
                                  <Link to={item.link}>{item.title}</Link>
                                </li>
                              ))}
                              <li className={headerStyles.all_service_btn}>
                                <Link to="/ux-ui-design-and-consulting-services">
                                  All Services{" "}
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    )}
                  </li>
                ))}
              </ul>
            </nav>
          </div>

          {scroll ? (
            <div className={headerStyles.buttonWrap} 
              style={{ visibility: `${currentUrl.includes('thank-you') ? 'hidden' : 'visible'}`, opacity: `${currentUrl.includes('thank-you') ? 0 : 1}`}}
            >
              <ButtonComponent
                buttonText={"Let's Start"}
                buttonStyle={"solidBg"}
                type={"onClick"}
                onClick={open}
              />
            </div>
          ) : (
            <div className={headerStyles.buttonWrap}
              style={{ visibility: `${currentUrl.includes('thank-you') ? 'hidden' : 'visible'}`, opacity: `${currentUrl.includes('thank-you') ? 0 : 1}`}}
            >
              <ButtonComponent
                buttonText={"Let's Start"}
                buttonStyle={`${
                  width < 1170 ? "solidBg" : "header"
                }`}
                type={"onClick"}
                onClick={open}
              />
            </div>
          )}
        </div>

        <div className={`${headerStyles.mobileMenu} ${menuOpen ? headerStyles.mobileMenuOpen : ""} mobileMenu`} style={{display: `${!!showSubMenu ? 'block' : 'flex'}`}}>
          <nav>
            <ul>
              {headerMenu.map((item, index) => (
                <li key={`arrayElement${index}`} className={pathName === item.url ? 'activeMenu' : ''}>
                  <MenuItem 
                    item={item} 
                    showSubMenu={showSubMenu} 
                    handleShowSubMenu={handleShowSubMenu} 
                  />
                  {item.label === "Services" && (
                    <>
                      <div className={`${headerStyles.mobileSubMenuBox} ${showSubMenu && headerStyles.mobileSubMenuBoxOpen}`} 
                        style={{ "--height": `${mobileSubMenuBoxHeight ? mobileSubMenuBoxHeight : 0}px` }} id="mobileSubMenuBox">
                        <ul className={headerStyles.mobileSubMenu}>
                          {megaMenu?.megaMenuOne.map((item, index) => (
                            <li key={`arrayElement${index}`}>
                              <Link to={item.link}>{item.title}</Link>
                            </li>
                          ))}
                        </ul>
                        <ul className={headerStyles.mobileSubMenu}>
                          {megaMenu?.megaMenuTwo.map((item, index) => (
                            <li key={`arrayElement${index}`}>
                              <Link to={item.link}>{item.title}</Link>
                            </li>
                          ))}
                        </ul>
                        <ul className={headerStyles.mobileSubMenu}>
                          <li className={headerStyles.allServicesMenu}>
                            <Link to="/ux-ui-design-and-consulting-services">All Services</Link>
                          </li>
                        </ul>
                      </div>

                    </>
                  )}
                </li>
              ))}
            </ul>
          </nav>

          <div className={headerStyles.buttonWrap}
            style={{ visibility: `${currentUrl.includes('thank-you') ? 'hidden' : 'visible'}`, opacity: `${currentUrl.includes('thank-you') ? 0 : 1}`}}
          >
            <ButtonComponent
              buttonText={"Let's Start"}
              buttonStyle={"solidBg"}
              type={"onClick"}
              onClick={open}
            />
          </div>
        </div>
      </header>

      <Modal.Root
        opened={opened}
        onClose={closeModal}
        transitionProps={{
          transition: "fade-up",
          duration: 100,
          timingFunction: "linear",
        }}
        yOffset={0}
        xOffset={0}
      >
        <Modal.Overlay
          style={{
            backgroundColor: `${innerWidth <= 1170 ? 'rgba(25,30,54,1)' : 'rgba(25,30,54,0.6)'}`,
          }}
        />

        {opened && (
          <button className={headerStyles.closeButton} onClick={closeModal}>
            <img src={crossButton} alt="crossButton" />
          </button>
        )}

        <Modal.Content
          style={{
            padding: "0",
            display: "block",
            marginTop: "auto",
            height: "90vh",
            alignSelf: "end",
            borderRadius: "20px 20px 0px 0px",
          }}
        >
          <SlideUpForm />
        </Modal.Content>
      </Modal.Root>
    </>
  );
}
